(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fr-sorority-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.body.classList.add('fr-sorority-page');
    document.querySelectorAll('[data-fr-sorority]').forEach((root) => {
      const input = root.querySelector('[data-sorority-search]');
      const clear = root.querySelector('[data-sorority-clear]');
      const cards = Array.from(root.querySelectorAll('[data-sorority-list] a'));
      const note = root.querySelector('[data-sorority-result-note]');
      const empty = root.querySelector('[data-sorority-empty]');
      const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      const filter = () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach((card) => {
          const match = !query || normalize(card.dataset.org).includes(query) || normalize(card.textContent).includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });
        note.textContent = query ? `${visible} organization${visible === 1 ? '' : 's'} found` : 'Showing all organizations';
        empty.hidden = visible !== 0;
      };
      input?.addEventListener('input', filter);
      clear?.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });

      const rail = root.querySelector('[data-sorority-product-rail]');
      root.querySelectorAll('[data-sorority-rail]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!rail) return;
          const amount = Math.max(rail.clientWidth * .72, 300);
          rail.scrollBy({ left: button.dataset.sororityRail === 'next' ? amount : -amount, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-omega-psi-phi"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slugify = (value) => {
      const normalized = value
        .toLowerCase()
        .trim()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

      return normalized || 'section';
    };

    const initializeArticle = (root) => {
      if (root.dataset.oppReady === 'true') return;
      root.dataset.oppReady = 'true';

      const content = root.querySelector('[data-opp-content]');
      const toc = root.querySelector('[data-opp-toc]');
      const list = root.querySelector('[data-opp-toc-list]');
      if (!content || !toc || !list) return;

      const headings = Array.from(content.querySelectorAll('h2, h3[data-toc]'));
      if (!headings.length) {
        toc.hidden = true;
        return;
      }

      const usedIds = new Set();
      headings.forEach((heading) => {
        let candidate = heading.id || slugify(heading.textContent);
        let uniqueId = candidate;
        let index = 2;

        while (
          usedIds.has(uniqueId) ||
          (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)
        ) {
          uniqueId = `${candidate}-${index}`;
          index += 1;
        }

        heading.id = uniqueId;
        usedIds.add(uniqueId);

        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.classList.add('is-subheading');

        const link = document.createElement('a');
        link.href = `#${uniqueId}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });

      const details = toc.querySelector('details');
      const mobileQuery = window.matchMedia('(max-width: 990px)');
      const applyDisclosureState = (event) => {
        if (!details) return;
        if (event.matches) details.removeAttribute('open');
        else details.setAttribute('open', '');
      };

      applyDisclosureState(mobileQuery);
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', applyDisclosureState);
      }

      const links = Array.from(list.querySelectorAll('a'));
      const setActive = (id) => {
        links.forEach((link) => {
          const isActive = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', isActive);
          if (isActive) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

            if (visible[0]) setActive(visible[0].target.id);
          },
          { rootMargin: '-18% 0px -68% 0px', threshold: [0, 1] }
        );

        headings.forEach((heading) => observer.observe(heading));
      }

      links.forEach((link) => {
        link.addEventListener('click', () => {
          const id = link.getAttribute('href').slice(1);
          setActive(id);
          if (mobileQuery.matches && details) details.removeAttribute('open');
        });
      });
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-opp-article]').forEach(initializeArticle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
